import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getEventChainLinks } from '../index';
export const useGetEventChainLinks = (query) => useQuery(['EventChainLinks', query], () => trackPromise(getEventChainLinks(query)), {
    cacheTime: 0,
    // Не сбрасываем таблицу в пустое состояние на время запроса следующей страницы.
    keepPreviousData: true,
});
